<template>
  <div id="app">
    <div class="row" style="padding-top: 2rem">
      <div class="col-4">
        <img src="../static/img/logo.png" style="float: right;max-width: 100%;"/>
      </div>
      <div class="col-3"></div>
      <div class="col-2" style="padding-right: 1rem;">
         <router-link to="/">
          <span class="header_btn" :style="{float: 'right',fontSize : 1.5*windowWidth/100+'px'}">首页</span>
        </router-link>
      </div>
      <div class="col-2" style="padding-left: 0.5rem;">
        <router-link to="/shop">
          <span class="header_btn" :style="{float: 'left',fontSize : 1.5*windowWidth/100+'px'}">礼包</span>
        </router-link>
      </div>
      <div class="col-3"></div>
    </div>
    <router-view/>
    <footer style="margin-top: 10px;">
      <p :style="{textAlign: 'center',fontSize : 1*windowWidth/100+'px'}"><img src="../static/img/guohui.png" style=""/>桂公网安备 45010802000614号 南宁君子好逑科技有限公司 <a href="https://beian.miit.gov.cn/">桂ICP备2023001130号</a></p>
  </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      windowWidth: 1920
    }
  },
  mounted () {
    this.windowWidth = document.body.clientWidth
  }
}
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: url(../static/img/haoqiubj.png);
  height: 100%;
  width: 100%;
  position:fixed;
  background-size:100% 100%;
  overflow-y: auto;
  overflow-x: hidden;
}


.header_btn {
  font-weight: 500;
  cursor: pointer;
  margin-top: 1rem;
  color: #000;
}
p{
  margin:0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue